import { createAction, props } from '@ngrx/store';

export enum GarageActionTypes {
    getGarageItems = '[Garage Items] get garage items',
    getGarageItemsFail = '[Garage Items] get garage items fail',
    getGarageItemsSuccess = '[Garage Items] get garage items success',
    setActiveGarageItemId = '[Garage Items] set active garage item id',
}
export const GetGarageItems = createAction(GarageActionTypes.getGarageItems);

export const GetGarageItemsSuccess = createAction(
    GarageActionTypes.getGarageItemsSuccess
);

export const GetGarageItemsFail = createAction(
    GarageActionTypes.getGarageItemsFail,
    props<{ errorMessage: string }>()
);

export const SetActiveGarageItemId = createAction(
    GarageActionTypes.setActiveGarageItemId,
    props<{ garageItemId: string }>()
);
